import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7044c10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-rating-input" }

import { computed, ref, watch, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'star-rating-input',
  props: {
  /**
   * The numeric value used with `v-model` to bind the component state. This typically represents an ID or a selected value.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },

  /**
   * The label displayed for the html editor control.
   * @type {String}
   * @required
   */
  label: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Number} value - The new value to be updated in the model.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const rating = computed({
  get: () => props.modelValue,
  set: (value: number) => emit("update:modelValue", value),
});

const firstStarActive = ref(false);
const secondStarActive = ref(false);
const thirdStarActive = ref(false);
const fourthStarActive = ref(false);
const fifthStarActive = ref(false);

const firstStarHover = ref(false);
const secondStarHover = ref(false);
const thirdStarHover = ref(false);
const fourthStarHover = ref(false);

const setStars = () => {
  if (rating.value == 0) {
    firstStarActive.value = false;
    secondStarActive.value = false;
    thirdStarActive.value = false;
    fourthStarActive.value = false;
    fifthStarActive.value = false;
    return;
  }

  if (rating.value == 1) {
    firstStarActive.value = true;
    secondStarActive.value = false;
    thirdStarActive.value = false;
    fourthStarActive.value = false;
    fifthStarActive.value = false;
    return;
  }

  if (rating.value == 2) {
    firstStarActive.value = true;
    secondStarActive.value = true;
    thirdStarActive.value = false;
    fourthStarActive.value = false;
    fifthStarActive.value = false;
    return;
  }

  if (rating.value == 3) {
    firstStarActive.value = true;
    secondStarActive.value = true;
    thirdStarActive.value = true;
    fourthStarActive.value = false;
    fifthStarActive.value = false;
    return;
  }

  if (rating.value == 4) {
    firstStarActive.value = true;
    secondStarActive.value = true;
    thirdStarActive.value = true;
    fourthStarActive.value = true;
    fifthStarActive.value = false;
    return;
  }

  if (rating.value == 5) {
    firstStarActive.value = true;
    secondStarActive.value = true;
    thirdStarActive.value = true;
    fourthStarActive.value = true;
    fifthStarActive.value = true;
    return;
  }
};

watch(
  () => rating.value,
  () => {
    setStars();
  },
);

onMounted(() => {
  setStars();
});

// When a star is clicked, if it's made inactive, all the following stars are also made inactive.
const starClicked = (star: number) => {
  switch (star) {
    case 1:
      if (!firstStarActive.value) {
        firstStarActive.value = true;
        rating.value = 1;
        return;
      }

      // If a start is already active and is clicked, all the active following stars are made inactive,
      if (secondStarActive.value) {
        secondStarActive.value = false;
        thirdStarActive.value = false;
        fourthStarActive.value = false;
        fifthStarActive.value = false;
        rating.value = 1;
      } else {
        // If there are no active following stars, the star is made active.
        firstStarActive.value = false;
        rating.value = 0;
      }
      break;
    case 2:
      if (!secondStarActive.value) {
        firstStarActive.value = true;
        secondStarActive.value = true;
        rating.value = 2;
        return;
      }

      if (thirdStarActive.value) {
        thirdStarActive.value = false;
        fourthStarActive.value = false;
        fifthStarActive.value = false;
        rating.value = 2;
      } else {
        secondStarActive.value = false;
        rating.value = 1;
      }
      break;
    case 3:
      if (!thirdStarActive.value) {
        firstStarActive.value = true;
        secondStarActive.value = true;
        thirdStarActive.value = true;
        rating.value = 3;
        return;
      }

      if (fourthStarActive.value) {
        fourthStarActive.value = false;
        fifthStarActive.value = false;
        rating.value = 3;
      } else {
        thirdStarActive.value = false;
        rating.value = 2;
      }
      break;
    case 4:
      if (!fourthStarActive.value) {
        firstStarActive.value = true;
        secondStarActive.value = true;
        thirdStarActive.value = true;
        fourthStarActive.value = true;
        rating.value = 4;
        return;
      }

      if (fifthStarActive.value) {
        fifthStarActive.value = false;
        rating.value = 4;
      } else {
        fourthStarActive.value = false;
        rating.value = 3;
      }
      break;
    case 5:
      if (!fifthStarActive.value) {
        firstStarActive.value = true;
        secondStarActive.value = true;
        thirdStarActive.value = true;
        fourthStarActive.value = true;
        fifthStarActive.value = true;
        rating.value = 5;
        return;
      } else {
        fifthStarActive.value = false;
        rating.value = 4;
      }
      break;
  }
};

// When a user hovers over a star, all the preceeding stars have the colours changed to a dark gold
const starHovered = (star: number) => {
  switch (star) {
    case 2:
      if (!secondStarActive.value) {
        firstStarHover.value = true;
      }
      break;
    case 3:
      if (!thirdStarActive.value) {
        firstStarHover.value = !firstStarActive.value;
        secondStarHover.value = !secondStarActive.value;
      }
      break;
    case 4:
      if (!fourthStarActive.value) {
        firstStarHover.value = !firstStarActive.value;
        secondStarHover.value = !secondStarActive.value;
        thirdStarHover.value = !thirdStarActive.value;
      }
      break;
    case 5:
      if (!fifthStarActive.value) {
        firstStarHover.value = !firstStarActive.value;
        secondStarHover.value = !secondStarActive.value;
        thirdStarHover.value = !thirdStarActive.value;
        fourthStarHover.value = !fourthStarActive.value;
      }
      break;
  }
};

// If a user hovers over a star and then moves off it without clicking it, \ll the stars are reset to
// there default grey state
const starUnhovered = () => {
  firstStarHover.value = false;
  secondStarHover.value = false;
  thirdStarHover.value = false;
  fourthStarHover.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(props.label), 1),
    _createElementVNode("div", null, [
      _createElementVNode("i", {
        class: _normalizeClass(["fa fa-star star-icon", { activeStar: firstStarActive.value, hoverStar: firstStarHover.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (starClicked(1))),
        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (starHovered(1))),
        onMouseleave: starUnhovered
      }, null, 34),
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-star star-icon", { activeStar: secondStarActive.value, hoverStar: secondStarHover.value }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (starClicked(2))),
        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (starHovered(2))),
        onMouseleave: starUnhovered
      }, null, 34),
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-star star-icon", { activeStar: thirdStarActive.value, hoverStar: thirdStarHover.value }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (starClicked(3))),
        onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (starHovered(3))),
        onMouseleave: starUnhovered
      }, null, 34),
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-star star-icon", { activeStar: fourthStarActive.value, hoverStar: fourthStarHover.value }]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (starClicked(4))),
        onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (starHovered(4))),
        onMouseleave: starUnhovered
      }, null, 34),
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-star star-icon", { activeStar: fifthStarActive.value }]),
        onClick: _cache[8] || (_cache[8] = ($event: any) => (starClicked(5))),
        onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (starHovered(5))),
        onMouseleave: starUnhovered
      }, null, 34)
    ])
  ]))
}
}

})